import { time } from '@/time';
import type { Recipe } from '@/types';

const recipe: Recipe = {
  title: 'Steak',
  source: 'https://www.seriouseats.com/reverse-seared-steak-recipe',
  totalTime: time(0, 10),
  servings: 2,
  tags: { type: 'main' },
  options: [
    {
      key: 'doneness',
      default: 'medium-rare',
      choices: [
        {
          key: 'rare',
          label: 'Rare ({!120F})',
          steps: {
            roast: { addTime: time(0, 20), text: '~{time} until {!105F}' },
            sear: { text: '{!120F}' },
          },
        },
        {
          key: 'medium-rare',
          label: 'Medium-rare ({!130F})',
          steps: {
            roast: { addTime: time(0, 25), text: '~{time} until {!115F}' },
            sear: { text: '{!130F}' },
          },
        },
        {
          key: 'medium',
          label: 'Medium ({!140F})',
          steps: {
            roast: { addTime: time(0, 30), text: '~{time} until {!125F}' },
            sear: { text: '{!140F}' },
          },
        },
      ],
    },
  ],
  ingredients: [
    { name: 'steaks', quantity: '2',
      note: '1.5–2-in thick (ribeye, NY strip or filet mignon)',
    },
    { name: 'kosher salt' },
    { name: 'black pepper' },
    { name: 'garlic powder' },
    { name: 'butter', quantity: '2', unit: 'tbsp' },
  ],
  directions: [
    {
      title: 'Season',
      bullets: [
        "Generously season {steaks} all over with {kosher salt}, {black pepper} & {garlic powder}",
        "(Optional) Set steaks on wire rack & refrigerate uncovered 1-24 hr to dry exterior",
      ],
    },
    {
      title: 'Roast',
      bullets: [
        "Set steaks on wire rack in rimmed baking sheet",
        "Preheat oven to {!250F}",
        "Cook in oven {opt:doneness:roast} internal temp",
      ],
    },
    {
      title: 'Sear',
      bullets: [
        "In skillet, heat {butter:half} over high until smoking",
        "Add steaks & {butter:half} to skillet",
        "Cook 1 min per side (2 min total) until each side is well browned",
        "(Optional) For darker crust, cook additional 1 min per side (4 min total)",
        "Hold steaks sideways with tongs to sear edges",
        "Final internal temp should be {opt:doneness:sear}",
        "Serve immediately — no need to rest reverse-seared steaks",
      ],
    },
  ],
};

export default recipe;
